import { proformaStateLabel } from './proformaState.ts';

/**
 * The offer-level roll-up of `offer_invoice_status.badge`. A non-split offer carries its
 * proforma's state; a split offer carries a summary of its installments, which is not a
 * proforma state and is never decoded as one.
 */
const SPLIT_LABELS: Record<string, string> = {
  'fully-paid': 'Fully settled',
  'partially-paid': 'Partly settled',
  'partially-invoiced': 'Partly invoiced',
  'not-invoiced': 'Not invoiced',
  'n/a': 'n/a',
};

export function offerInvoiceBadgeLabel(badge: string): string {
  return SPLIT_LABELS[badge] ?? proformaStateLabel(badge);
}
